var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-powerup-percentage"},[_c('span',{staticClass:"game-powerup-percentage__progress",style:({ transform: ("scaleX(" + (_vm.$store.state.powerUpPercentage) + ")") })})])}
var staticRenderFns = []

export { render, staticRenderFns }